import { GenericGeoEvent } from 'features/geoEvents/geoEvent.types';

/**
 * Key for components with uncontrolled rich text editors (which ignore form
 * resets) so they remount from fresh incident data when the incident updates.
 * Use it in forms that reset from incident data, either through
 * `useResetOnInitialValuesChange` or the `values` option of `useForm`.
 *
 * Don't use it for fields listed in `preserveFields` of
 * `useResetOnInitialValuesChange`: the remount would replace the preserved
 * text with the incident's value.
 */
export const getIncidentRemountKey = (
  prefix: string,
  geoEvent?: Pick<GenericGeoEvent, 'id' | 'dateModified'>,
): string => `${prefix}-${geoEvent?.id}-${geoEvent?.dateModified}`;
